export async function calculateTotalQuantityByItemAsync(objects) {
  const aggregation = objects
    .filter((obj) => obj.status === "C")
    .reduce((acc, transaction) => {
      transaction.items?.forEach((item) => {
        const { code: itemCode, description, quantity } = item;
        const itemQuantity = parseInt(quantity, 10);
        const unitPrice = parseFloat(
          item.customProperties.find((prop) => prop.codeName === "UNIT_PRICE")
            ?.value || 0,
        );

        if (!isNaN(itemQuantity) && !isNaN(unitPrice) && unitPrice > 0) {
          const itemSales = unitPrice * itemQuantity;

          if (!acc[itemCode]) {
            acc[itemCode] = {
              quantity: itemQuantity,
              sales: itemSales,
              description,
              code: itemCode,
            };
          } else {
            acc[itemCode].quantity += itemQuantity;
            acc[itemCode].sales += itemSales;
          }
        }
      });
      return acc;
    }, {});

  return aggregation;
}

// export async function calculateTotalSalesByItemAsync(objects) {
//   console.log("NEW COMPUTATION", objects);
//   const aggregation = objects
//     .filter((obj) => obj.status === "C")
//     .reduce((acc, transaction) => {
//       transaction.items?.forEach((item) => {
//         const { code: itemCode, description, quantity } = item;
//         const itemQuantity = parseInt(quantity, 10);
//         const unitPrice = parseFloat(
//           item.customProperties.find((prop) => prop.codeName === "UNIT_PRICE")
//             ?.value || 0
//         );

//         if (!isNaN(itemQuantity) && !isNaN(unitPrice) && unitPrice > 0) {
//           // const itemSales = unitPrice * itemQuantity;
//           const itemSales = unitPrice;

//           if (!acc[itemCode]) {
//             acc[itemCode] = {
//               sales: itemSales,
//               quantity: itemQuantity,
//               description,
//             };
//           } else {
//             acc[itemCode].sales += itemSales;
//             acc[itemCode].quantity += itemQuantity;
//           }
//         }
//       });
//       return acc;
//     }, {});

//   return aggregation;
// }

/**
 * Compute total sales by item code.
 * Options:
 *  - onlyCodes: array of codes to include (e.g., ["00161"]) — useful for debugging
 *  - log: true to print per-item computations
 */
// export async function calculateTotalSalesByItemAsync(objects, options = {}) {
//   const { onlyCodes = null, log = false } = options;
//   const aggregation = {};

//   for (const t of objects ?? []) {
//     if (!t || t.status !== "C") continue;

//     const discount = parseNum(t.discount_amount);
//     const taxfree = parseNum(t.total_taxfree);

//     for (const it of t.items ?? []) {
//       const itemCode = String(it?.code ?? "").trim(); // normalize
//       if (onlyCodes && !onlyCodes.includes(itemCode)) continue;

//       const description = it?.description ?? "";
//       const qty = parseNum(it?.quantity);
//       const unit = parseNum(
//         it?.customProperties?.find((p) => p?.codeName === "UNIT_PRICE")?.value
//       );

//       if (qty <= 0) continue;

//       // Your rule:
//       const itemSales = (unit + discount + taxfree) * qty;

//       if (log) {
//         console.log(
//           `[DBG] txn=${t.id} code=${itemCode} desc=${description} ` +
//             `qty=${qty} unit=${unit} disc=${discount} taxfree=${taxfree} -> sales=${itemSales}`
//         );
//       }

//       if (!aggregation[itemCode]) {
//         aggregation[itemCode] = { sales: 0, quantity: 0, description };
//       }
//       aggregation[itemCode].sales += itemSales;
//       aggregation[itemCode].quantity += qty;
//     }
//   }

//   return aggregation;

//   function parseNum(v) {
//     if (v == null) return 0;
//     return parseFloat(String(v).replace(/,/g, "")) || 0;
//   }
// }

// export async function calculateTotalSalesByItemAsync(objects) {
//   console.log("NEW COMPUTATION", objects);

//   const aggregation = objects
//     .filter((obj) => obj.status === "C")
//     .reduce((acc, transaction) => {
//       const discountAmount = parseFloat(transaction.discount_amount || 0);
//       const taxFree = parseFloat(transaction.total_taxfree || 0);

//       transaction.items?.forEach((item) => {
//         const { code: itemCode, description, quantity } = item;
//         const itemQuantity = parseFloat(quantity || 0);
//         const unitPrice = parseFloat(
//           item.customProperties.find((prop) => prop.codeName === "UNIT_PRICE")
//             ?.value || 0
//         );

//         // ✅ Skip items where unit price is 0.00
//         if (unitPrice === 0) return;

//         if (!isNaN(itemQuantity) && itemQuantity > 0) {
//           // Formula: (unitPrice + discount + taxFree) * quantity
//           const itemSales =
//             (unitPrice + discountAmount + taxFree) * itemQuantity;

//           if (!acc[itemCode]) {
//             acc[itemCode] = {
//               sales: itemSales,
//               quantity: itemQuantity,
//               description,
//             };
//           } else {
//             acc[itemCode].sales += itemSales;
//             acc[itemCode].quantity += itemQuantity;
//           }
//         }
//       });
//       return acc;
//     }, {});

//   return aggregation;
// }

const tranTypeMapping = {
  U: "Delivery",
  D: "Dine In",
  T: "Take Out",
  G: "GrabFood",
  F: "FoodPanda",
  P: "Pick Up",
  B: "Del Time",
  K: "Drive-thru",
  H: "Tablevibe",
};

function initItemBucket(acc, itemCode, description) {
  if (!acc[itemCode]) {
    acc[itemCode] = {
      sales: 0,
      quantity: 0,
      description,
      dineInRevenue: 0,
      dineInSold: 0,
      takeOutRevenue: 0,
      takeOutSold: 0,
      grabRevenue: 0,
      grabSold: 0,
      foodPandaRevenue: 0,
      foodPandaSold: 0,
      deliveryRevenue: 0,
      deliverySold: 0,
      pickUpRevenue: 0,
      pickUpSold: 0,
      delTimeRevenue: 0,
      deltimeSold: 0, // note: using the exact key you listed
      driveThruRevenue: 0,
      driveThruSold: 0,
      tableVibeRevenue: 0,
      tableVibeSold: 0,
    };
  }
}

function channelKeys(channel) {
  switch (channel) {
    case "Dine In":
      return { rev: "dineInRevenue", qty: "dineInSold" };
    case "Take Out":
      return { rev: "takeOutRevenue", qty: "takeOutSold" };
    case "GrabFood":
      return { rev: "grabRevenue", qty: "grabSold" };
    case "FoodPanda":
      return { rev: "foodPandaRevenue", qty: "foodPandaSold" };
    case "Delivery":
      return { rev: "deliveryRevenue", qty: "deliverySold" };
    case "Pick Up":
      return { rev: "pickUpRevenue", qty: "pickUpSold" };
    case "Del Time":
      return { rev: "delTimeRevenue", qty: "deltimeSold" };
    case "Drive-thru":
      return { rev: "driveThruRevenue", qty: "driveThruSold" };
    case "Tablevibe":
      return { rev: "tableVibeRevenue", qty: "tableVibeSold" };
    default:
      return null;
  }
}

// export async function calculateTotalSalesByItemAsync(objects) {
//   const aggregation = objects
//     .filter((obj) => obj.status === "C")
//     .reduce((acc, transaction) => {
//       const discountAmount = parseFloat(transaction.discount_amount || 0);
//       const taxFree = parseFloat(transaction.total_taxfree || 0);
//       const channel = tranTypeMapping[transaction.tran_type] || null;
//       const keys = channelKeys(channel);

//       transaction.items?.forEach((item) => {
//         const { code: itemCode, description, quantity } = item;
//         const itemQuantity = parseFloat(quantity || 0);
//         const unitPrice = parseFloat(
//           item.customProperties.find((p) => p?.codeName === "UNIT_PRICE")
//             ?.value || 0,
//         );

//         // Skip items where unit price is 0.00
//         if (unitPrice === 0) return;
//         if (isNaN(itemQuantity) || itemQuantity <= 0) return;

//         // Your formula (kept as-is):
//         // const itemSales = (unitPrice + discountAmount + taxFree) * itemQuantity;
//         const itemSales = unitPrice * itemQuantity;

//         // Ensure bucket exists
//         initItemBucket(acc, itemCode, description);

//         // Update totals
//         acc[itemCode].sales += itemSales;
//         acc[itemCode].quantity += itemQuantity;

//         // Per-channel splits (only if we recognize the channel)
//         if (keys) {
//           acc[itemCode][keys.rev] += itemSales;
//           acc[itemCode][keys.qty] += itemQuantity;
//         }
//       });

//       return acc;
//     }, {});

//   return aggregation;
// }

export async function calculateTotalSalesByItemAsync(objects) {
  const aggregation = objects
    .filter((obj) => obj.status === "C")
    .reduce((acc, transaction) => {
      const discountAmount = parseFloat(transaction.discount_amount || 0);
      const taxFree = parseFloat(transaction.total_taxfree || 0);
      const channel = tranTypeMapping[transaction.tran_type] || null;
      const keys = channelKeys(channel);
      const storeCode = transaction.store_code;

      transaction.items?.forEach((item) => {
        const { code: itemCode, description, quantity } = item;
        const itemQuantity = parseFloat(quantity || 0);
        const unitPrice = parseFloat(
          item.customProperties.find((p) => p?.codeName === "UNIT_PRICE")
            ?.value || 0,
        );

        // Skip items where unit price is 0.00
        if (unitPrice === 0) return;
        if (isNaN(itemQuantity) || itemQuantity <= 0) return;

        const itemSales = unitPrice * itemQuantity;

        // Ensure bucket exists
        initItemBucket(acc, itemCode, description);

        // Update overall totals
        acc[itemCode].sales += itemSales;
        acc[itemCode].quantity += itemQuantity;

        // Per-channel splits (only if we recognize the channel)
        if (keys) {
          acc[itemCode][keys.rev] += itemSales;
          acc[itemCode][keys.qty] += itemQuantity;
        }

        // **Track per store**
        if (!acc[itemCode].stores) {
          acc[itemCode].stores = {};
        }

        if (!acc[itemCode].stores[storeCode]) {
          acc[itemCode].stores[storeCode] = initStoreMetrics();
        }

        // Update store totals
        acc[itemCode].stores[storeCode].sales += itemSales;
        acc[itemCode].stores[storeCode].quantity += itemQuantity;

        // Update store channel metrics
        if (keys) {
          acc[itemCode].stores[storeCode][keys.rev] += itemSales;
          acc[itemCode].stores[storeCode][keys.qty] += itemQuantity;
        }
      });

      return acc;
    }, {});

  return aggregation;
}

export async function calculateTotalSalesByItemAsyncSearch(objects) {
  console.log("PUSO", objects);
  const aggregation = objects
    .filter((obj) => obj.status === "C")
    .reduce((acc, transaction) => {
      const discountAmount = parseFloat(transaction.discount_amount || 0);
      const taxFree = parseFloat(transaction.total_taxfree || 0);
      const channel = tranTypeMapping[transaction.tran_type] || null;
      const keys = channelKeys(channel);
      const storeCode = transaction.store_code;
      const tranDate = transaction.tran_date; // Get transaction date

      transaction.items?.forEach((item) => {
        const { code: itemCode, description, quantity } = item;
        const itemQuantity = parseFloat(quantity || 0);
        const unitPrice = parseFloat(
          item.customProperties.find((p) => p?.codeName === "UNIT_PRICE")
            ?.value || 0,
        );

        // Skip invalid items
        if (unitPrice === 0 || isNaN(itemQuantity) || itemQuantity <= 0) return;

        const itemSales = unitPrice * itemQuantity;

        // Initialize item bucket
        initItemBucket(acc, itemCode, description);

        // Update overall totals
        acc[itemCode].sales += itemSales;
        acc[itemCode].quantity += itemQuantity;
        acc[itemCode].unitPrice = Number(unitPrice);
        acc[itemCode].sku = itemCode;

        // Per-channel splits (overall)
        if (keys) {
          acc[itemCode][keys.rev] += itemSales;
          acc[itemCode][keys.qty] += itemQuantity;
        }

        // **Track per store**
        if (!acc[itemCode].stores) {
          acc[itemCode].stores = {};
        }
        if (!acc[itemCode].stores[storeCode]) {
          acc[itemCode].stores[storeCode] = {
            sales: 0,
            quantity: 0,
            ...initStoreMetrics(),
            dates: {}, // ADD: Track per date
          };
        }

        // Update store totals
        acc[itemCode].stores[storeCode].sales += itemSales;
        acc[itemCode].stores[storeCode].quantity += itemQuantity;

        // Update store channel metrics
        if (keys) {
          acc[itemCode].stores[storeCode][keys.rev] += itemSales;
          acc[itemCode].stores[storeCode][keys.qty] += itemQuantity;
        }

        // **NEW: Track per date inside store**
        const dateKey = tranDate.split(" ")[0]; // Extract "2026-01-23"

        if (!acc[itemCode].stores[storeCode].dates[dateKey]) {
          acc[itemCode].stores[storeCode].dates[dateKey] = initStoreMetrics();
        }

        // Update date-specific metrics
        acc[itemCode].stores[storeCode].dates[dateKey].sales += itemSales;
        acc[itemCode].stores[storeCode].dates[dateKey].quantity += itemQuantity;

        if (keys) {
          acc[itemCode].stores[storeCode].dates[dateKey][keys.rev] += itemSales;
          acc[itemCode].stores[storeCode].dates[dateKey][keys.qty] +=
            itemQuantity;
        }
      });

      return acc;
    }, {});

  return aggregation;
}

// Helper function to initialize store metrics
function initStoreMetrics() {
  return {
    sales: 0,
    quantity: 0,
    dineInRevenue: 0,
    dineInSold: 0,
    takeOutRevenue: 0,
    takeOutSold: 0,
    grabRevenue: 0,
    grabSold: 0,
    foodPandaRevenue: 0,
    foodPandaSold: 0,
    deliveryRevenue: 0,
    deliverySold: 0,
    pickUpRevenue: 0,
    pickUpSold: 0,
    delTimeRevenue: 0,
    deltimeSold: 0,
    driveThruRevenue: 0,
    driveThruSold: 0,
    tableVibeRevenue: 0,
    tableVibeSold: 0,
  };
}

// export async function calculateTotalSalesByItemAsyncSearch(objects) {
//   console.log("PUSO", objects);

//   const aggregation = objects
//     .filter((obj) => obj.status === "C")
//     .reduce((acc, transaction) => {
//       const discountAmount = parseFloat(transaction.discount_amount || 0);
//       const taxFree = parseFloat(transaction.total_taxfree || 0);
//       const channel = tranTypeMapping[transaction.tran_type] || null;
//       const keys = channelKeys(channel);
//       const storeCode = transaction.store_code;

//       transaction.items?.forEach((item) => {
//         const { code: itemCode, description, quantity } = item;
//         const itemQuantity = parseFloat(quantity || 0);
//         const unitPrice = parseFloat(
//           item.customProperties.find((p) => p?.codeName === "UNIT_PRICE")
//             ?.value || 0,
//         );

//         // Skip invalid items
//         if (unitPrice === 0 || isNaN(itemQuantity) || itemQuantity <= 0) return;

//         const itemSales = unitPrice * itemQuantity;

//         // Initialize item bucket
//         initItemBucket(acc, itemCode, description);

//         // Update overall totals
//         acc[itemCode].sales += itemSales;
//         acc[itemCode].quantity += itemQuantity;

//         // Per-channel splits (overall)
//         if (keys) {
//           acc[itemCode][keys.rev] += itemSales;
//           acc[itemCode][keys.qty] += itemQuantity;
//         }

//         // **Track per store**
//         if (!acc[itemCode].stores) {
//           acc[itemCode].stores = {};
//         }

//         if (!acc[itemCode].stores[storeCode]) {
//           acc[itemCode].stores[storeCode] = initStoreMetrics();
//         }

//         // Update store totals
//         acc[itemCode].stores[storeCode].sales += itemSales;
//         acc[itemCode].stores[storeCode].quantity += itemQuantity;

//         // Update store channel metrics
//         if (keys) {
//           acc[itemCode].stores[storeCode][keys.rev] += itemSales;
//           acc[itemCode].stores[storeCode][keys.qty] += itemQuantity;
//         }
//       });

//       return acc;
//     }, {});

//   return aggregation;
// }

// // Helper function to initialize store metrics
// function initStoreMetrics() {
//   return {
//     sales: 0,
//     quantity: 0,
//     dineInRevenue: 0,
//     dineInSold: 0,
//     takeOutRevenue: 0,
//     takeOutSold: 0,
//     grabRevenue: 0,
//     grabSold: 0,
//     foodPandaRevenue: 0,
//     foodPandaSold: 0,
//     deliveryRevenue: 0,
//     deliverySold: 0,
//     pickUpRevenue: 0,
//     pickUpSold: 0,
//     delTimeRevenue: 0,
//     deltimeSold: 0,
//     driveThruRevenue: 0,
//     driveThruSold: 0,
//     tableVibeRevenue: 0,
//     tableVibeSold: 0,
//   };
// }

export async function calculateFreeItemsBySKUAsync(objects) {
  const freeItems = objects.reduce((acc, transaction) => {
    transaction.items?.forEach((item) => {
      const { code: itemCode, description, quantity } = item;
      const itemQuantity = parseInt(quantity, 10);

      // Get UNIT_PRICE
      const unitPrice = parseFloat(
        item.customProperties.find((prop) => prop.codeName === "UNIT_PRICE")
          ?.value || 0,
      );

      // If unit price is exactly 0.00, it's a free item
      if (!isNaN(unitPrice) && unitPrice === 0) {
        if (!acc[itemCode]) {
          acc[itemCode] = {
            sales: 0,
            quantity: itemQuantity,
            description,
          };
        } else {
          acc[itemCode].quantity += itemQuantity;
        }
      }
    });

    return acc;
  }, {});

  return freeItems;
}
